import { render, staticRenderFns } from "./Booklet.vue?vue&type=template&id=12a2b080&scoped=true&"
import script from "./Booklet.vue?vue&type=script&lang=js&"
export * from "./Booklet.vue?vue&type=script&lang=js&"
import style0 from "./Booklet.vue?vue&type=style&index=0&id=12a2b080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2b080",
  null
  
)

export default component.exports